import React from "react";
import "./RowSpace.scss";
const RowSpace = ({ margin }) => {


  return <div style={{ marginBottom: margin }} />;
};
export default RowSpace;
